import React from 'react';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage, useIntl } from '@futrli/localisation';

import { ActivationEvent } from '../../billing-in-app/components/activate-product-dialog/activate-product-sidebar';

interface Props {
  onSubmit: (event: ActivationEvent) => void;
  titleMessage: string;
}

export const PaymentCompleteDialog = ({ onSubmit, titleMessage }: Props) => {
  const intl = useIntl();
  return (
    <Dialog
      open={true}
      data-testid="payment-complete-dialog"
      aria-label={intl.formatMessage({
        id: 'billing.payment_complete_dialog.aria_label',
        defaultMessage: 'Payment complete dialog'
      })}
      title={titleMessage}
    >
      <Form>
        <Button fullWidth={true} onClick={onSubmit} buttonType="primary">
          <FormattedMessage id="common.lets_go" defaultMessage="Let's go!" />
        </Button>
      </Form>
    </Dialog>
  );
};
